import { render, staticRenderFns } from "./w-3-1.vue?vue&type=template&id=47b30f16"
import script from "./w-3-1.vue?vue&type=script&lang=js"
export * from "./w-3-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports